"use client";
import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import dynamic from "next/dynamic";
import { persistStore } from "redux-persist";
import { usePathname } from "next/navigation"; 
import store from "../redux/store";
import Loading from "./loading";

// Dynamic imports
const Navbar = dynamic(() => import("../components/navbar"), {
    ssr: false,
    loading: () => <div className="h-16 bg-gray-900" />,
});
const Footer = dynamic(() => import("../components/footer"), {
    ssr: false,
    loading: () => <div className="h-32 bg-gray-900" />,
});
const InactivityHandler = dynamic(() => import("../components/inactivityHandler"), {
    ssr: false,
});
const AppInitializer = dynamic(() => import("./appInitializer"), {
    ssr: false,
});

const persistor = persistStore(store);

export default function ClientLayout({ children }: { children: React.ReactNode }) {
    const pathname = usePathname(); // Get current route

    // Define routes where Navbar should be hidden
    const hideNavbarRoutes = ["/dashboard/[id]"]; // Adjust based on your route structure
    const shouldHideNavbar = hideNavbarRoutes.some((route) =>
        pathname?.match(new RegExp(`^${route.replace("[id]", "[^/]+")}$`))
    );

    return (
        <Provider store={store}>
            <PersistGate loading={<Loading />} persistor={persistor}>
                <AppInitializer>
                    {!shouldHideNavbar && <Navbar />} 
                    <InactivityHandler />
                    <main>{children}</main>
                    <div className="mt-16 sm:mt-8">
                        <Footer />
                    </div>
                </AppInitializer>
            </PersistGate>
        </Provider>
    );
}